import { createContext, useContext, ReactNode } from 'react';

/**
 * Visual variant for {@link WizardAccordion} headers. Steps that want the
 * design's off‑white + serif red title style wrap their accordions in
 * `<WizardAccordionStyleProvider variant="describe">`. Other steps inherit
 * `'default'` and render the standard MUI chrome.
 *
 * Context-scoped (rather than per-prop) so individual Section components
 * stay reusable without carrying step-specific styling.
 */
export type WizardAccordionVariant = 'default' | 'describe';

export const WizardAccordionStyleContext =
  createContext<WizardAccordionVariant>('default');

export function useWizardAccordionVariant(): WizardAccordionVariant {
  return useContext(WizardAccordionStyleContext);
}

export interface WizardAccordionStyleProviderProps {
  variant: WizardAccordionVariant;
  children: ReactNode;
}

export function WizardAccordionStyleProvider({
  variant,
  children,
}: WizardAccordionStyleProviderProps): JSX.Element {
  return (
    <WizardAccordionStyleContext.Provider value={variant}>
      {children}
    </WizardAccordionStyleContext.Provider>
  );
}
